import createQueryDuck from '@/redux/query';

import serializer from '../serializer';
import { getQueryRoot } from '../utils';

export default createQueryDuck('merchant', {
  getRoot: getQueryRoot,
  serializer,
});
